module.exports = __webpack_public_path__ + "static/kwekkwek-72adf38ab3a8accbd251afa7815e9089.jpg";